import React, { useEffect, useRef, useState, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Carousel } from "primereact/carousel";

// ------------------ COMPONENTES DE BASE--------------------------
import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { toastShow } from "../../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API---------------------------
import { generarCierre, generarCierreMP, generarExcelCierre, generarExcelCierreMP, getInventarioMateriaPrima, getMesCierre } from "../../../../API/Suministros/Inventario/InventarioRequest";
import { getListadoImagenes, mostrarImagenesProductos } from "../../../../Base/API/IT/Imagenes/ImagenesRequest";
import { TabPanel, TabView } from "primereact/tabview";
import { ConfirmDialog } from "primereact/confirmdialog";
import InventarioHistoricoTabMP from "./InventarioHistoricoTabMP";
import TomaInventarioScreen from "../../Suministros/Inventario/TomaInventarioScreen";


const InventarioMateriaPrimaScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [inventario, setInventario] = useState([]);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
  const [imagenes, setImagenes] = useState([]);
  const [showDialogCodigo, setShowDialogCodigo] = useState(false);
  const [selected, setSelected] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [mesCierre, setMesCierre] = useState({});
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [accesoGenerarCierre, setAccesoGenerarCierre] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(56));

  const getInfo = async () => {
    setLoading(true);
    const inventarioTempo = await getInventarioMateriaPrima();
    setInventario(inventarioTempo);
    const tempoMesCierre = await getMesCierre(2)
    setMesCierre(tempoMesCierre[0])
    setLoading(false);
  };

  const verImagen = async (rowData) => {
    let variable = await getImagenes(rowData);
    setImagenes(variable);
    if (variable) {
      setShowDialog(true);
      setSelectedImg(rowData);
    } else {
      toastShow(toast, "warn", "Advertencia", "El Producto no tiene imágenes.");
    }
  };

  const getImagenes = async (rowData) => {
    const i = await getListadoImagenes(rowData?.CodigoProducto);
    if (i?.length > 0) {
      let n = await Promise.all(
        i.map(async (e) => {
          try {
            const a = await mostrarImagenesProductos( rowData?.CodigoProducto, e );
            return a;
          } catch (e) {
            return e;
          }
        })
      );
      return { CodigoProducto: rowData?.CodigoProducto , img: n };
    } else {
      return;
    }
  };

  
  const columns = [
    {
      field: "IdProduct",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
      alignFrozen: "left",
    },
    {
      header: "Código",
      handerEn: "Code",
      field: "CodigoProducto",
      className: "Xsmall",
      Sumary: "count",
      Format: "Modal",
      frozen: true,
      alignFrozen: "left",
    },
    {
      header: "Producto",
      handerEn: "Product",
      field: "NombreProducto",
      className: "Xlarge",
      frozen: true,
      alignFrozen: "left",
    },
    {
      header: "Descripción",
      handerEn: "Description",
      field: "DescripcionProducto",
      className: "XXlarge",
    },
    {
      header: "Tipo Producto",
      handerEn: "Product Type",
      field: "NombreCategoria",
      className: "Xsmall",
    },
    {
      header: "Categoría",
      handerEn: "Category",
      field: "NombreSubcategoria",
      className: "Xsmall",
    },
    {
      header: "SubCategoría",
      handerEn: "SubCategory",
      field: "NombreTipoProducto",
      className: "small",
    },
    {
      header: "Unidad",
      handerEn: "Unit",
      field: "UnitName",
      className: "Xsmall",
    },


    //INICIALES
    {
      headerName: "Iniciales",
      children: [
        {
          header: "Inicial",
          handerEn: "Initial",
          field: "Inicial",
          className: "Xsmall",
          Sumary: "sum",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "Precio L",
          handerEn: "Price L",
          field: "PrecioInicialL",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "Monto L",
          handerEn: "Mounth L",
          field: "InicialMontol",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio $",
          handerEn: "Price $",
          field: "PrecioInicialD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto $",
          handerEn: "Mounth $",
          editable: userAuth?.IdRol === 1,
          field: "InicialMontoD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },

    mostrarDetalle ?
    // COMPRAS REALES
    {
      headerName: "Compras Reales",
      children: [
        {
          header: "ComprasReales",
          handerEn: "Purchase",
          field: "ComprasReales",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio L",
          handerEn: "Price L",
          field: "ComprasRealPrecioL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Precio $",
          handerEn: "Price $",
          field: "ComprasRealPrecioD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto L",
          handerEn: "Mounth L",
          field: "ComprasRealMontoL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Monto $",
          editable: userAuth?.IdRol === 1,
          handerEn: "Mounth $",
          field: "ComprasRealMontoD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,
    
    //DEVOLUCION PROVEEDOR
    mostrarDetalle ?
    {
      headerName: "Devolución Proveedor",
      children: [
        {
          header: "Devolucion Proveedor",
          handerEn: "",
          field: "DevolucionProveedor",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio L",
          handerEn: "PriceL",
          field: "PrecioDevProveedorL",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "Precio $",
          handerEn: "Price $",
          field: "PrecioDevProveedorD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto L",
          handerEn: "Mounth L",
          editable: userAuth?.IdRol === 1,
          field: "MontoDevProveedorL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Monto $",
          editable: userAuth?.IdRol === 1,
          handerEn: "Mounth $",
          field: "MontoDevProveedorD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,

    // COMPRAS
    {
      headerName: "Compras",
      children: [
        {
          header: "Compras",
          handerEn: "Purchase",
          field: "Compras",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio L",
          handerEn: "PriceL",
          editable: userAuth?.IdRol === 1,
          field: "ComprasPrecioL",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Precio $",
          editable: userAuth?.IdRol === 1,
          handerEn: "Price $",
          field: "ComprasPrecioD",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto L",
          handerEn: "Mounth L",
          field: "ComprasMontoL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Monto $",
          handerEn: "Mounth $",
          className: "Xsmall",
          field: "ComprasMontoD",          
          editable: userAuth?.IdRol === 1,
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },

    //SALIDAS REALES
    mostrarDetalle ?
    {
      headerName: "Salidas Reales",
      children: [
        {
          header: "SalidasReales",
          handerEn: "Output",
          field: "SalidasReales",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio L",
          editable: userAuth?.IdRol === 1,
          handerEn: "PriceL",
          field: "PrecioSalidaRealL",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Precio $",
          handerEn: "Price $",
          editable: userAuth?.IdRol === 1,
          field: "PrecioSalidaRealD",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto L",
          editable: userAuth?.IdRol === 1,
          handerEn: "Mounth L",
          field: "MontoSalidaRealL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Monto $",
          handerEn: "Mounth $",
          editable: userAuth?.IdRol === 1,
          field: "MontoSalidaRealD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,
    
    //DEVOLUCION INTERNA
    mostrarDetalle ?
    {
      headerName: "Devolución Interna",
      children: [
        {
          header: "Devolucion Interna",
          handerEn: "",
          field: "DevolucionInterna",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio L",
          handerEn: "PriceL",
          field: "PrecioDevInternaL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          editable: userAuth?.IdRol === 1,
          header: "Precio $",
          handerEn: "Price $",
          field: "PrecioDevInternaD",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto L",
          editable: userAuth?.IdRol === 1,
          handerEn: "Mounth L",
          field: "MontoDevInternaL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Monto $",
          handerEn: "Mounth $",
          editable: userAuth?.IdRol === 1,
          field: "MontoDevInternaD",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    } : null,

    //SALIDAS
    {
      headerName: "Salidas",
      children: [
        {
          header: "Salidas",
          handerEn: "Output",
          field: "Salidas",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio L",
          handerEn: "PriceL",
          field: "PrecioSalidaL",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Precio $",
          handerEn: "Price $",
          field: "PrecioSalidaD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto L",
          handerEn: "Mounth L",
          editable: userAuth?.IdRol === 1,
          field: "MontoSalidaL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Monto $",
          handerEn: "Mounth $",
          field: "MontoSalidaD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },


    //INVENTARIO CALCULADO
    {
      headerName: "Inventario Calculado",
      children: [
        {
          header: "Inv. Calculado",
          handerEn: "",
          field: "InventarioCalculado",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Precio L",
          handerEn: "PriceL",
          field: "InvPrecioL",
          className: "Xsmall",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
        },
        {
          header: "Precio $",
          handerEn: "Price $",
          field: "InvPrecioD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Format: "Currency",
        },
        {
          header: "Monto L",
          editable: userAuth?.IdRol === 1,
          handerEn: "Mounth L",
          field: "InvMontoL",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
        {
          header: "Monto $",
          handerEn: "Mounth $",
          field: "InvMontoD",
          editable: userAuth?.IdRol === 1,
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
        },
      ],
    },

    //INVENTARIO
    {
      headerName: "Inventario",
      children: [
        {
          header: "Inv",
          handerEn: "",
          field: "Inventario",
          className: "Xsmall",
          Sumary: "sum",
          editable: userAuth?.IdRol === 1,
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
        {
          header: "DIFF",
          editable: userAuth?.IdRol === 1,
          handerEn: "",
          field: "DIFF",
          className: "Xsmall",
          Sumary: "sum",
          Format: "Currency",
          frozen: true,
          alignFrozen: "right",
        },
        // {
        //   field: "IdProduct",
        //   header: "",
        //   Format: "Botones",
        //   frozen: true,
        //   alignFrozen: "right",
        //   filter: false,
        //   Botones: [
        //     {
        //       icon: "pi pi-print",
        //       tooltip: "Imprimir",
        //       onClick: (rowData) => {
        //         if(rowData?.IdProduct){
        //           if(selected.length === 0){
        //             setShowDialogCodigo(true);
        //             setSelected([rowData]);
        //           }else{
        //             setShowDialogCodigo(true);
        //             setSelected(selected);
        //           }
        //         }
        //       },
        //       tooltipOptions: {
        //         position: "right",
        //       },
        //     },
        //     {
        //       icon: "pi pi-eye",
        //       tooltip: "Img",
        //       onClick: async (rowData) => {
        //         if(rowData?.IdProduct){
        //           verImagen(rowData)
        //         }
        //       },
        //       tooltipOptions: {
        //         position: "top",
        //       },
        //     },
        //   ],
        // },
      ],
    },

    {
      header: "Monto L",
      handerEn: "Mounth L",
      field: "MontoL",
      className: "Xsmall",
      editable: userAuth?.IdRol === 1,
      Sumary: "sum",
      Format: "Currency",
      hidden: mostrarDetalle
    },
    {
      header: "Monto $",
      handerEn: "Mounth $",
      field: "MontoD",
      className: "Xsmall",
      Sumary: "sum",
      editable: userAuth?.IdRol === 1,
      Format: "Currency",
      hidden: mostrarDetalle,
    },
    {
      header: "Diff. MontoL",
      handerEn: "",
      field: "MontoLDIFF",
      className: "Xsmall",
      Sumary: "sum",
      editable: userAuth?.IdRol === 1,
      Format: "Currency",
      hidden: mostrarDetalle
    },
    {
      header: "Diff. Monto $",
      handerEn: "",
      field: "MontoDDIFF",
      className: "Xsmall",
      Sumary: "sum",
      editable: userAuth?.IdRol === 1,
      Format: "Currency",
      hidden: mostrarDetalle
    },


  ];

  // const columns = [
  //   {
  //     field: "IdProduct",
  //     header: "ID",
  //     headerEn: "ID",
  //     hidden: userAuth.IdRol === 1,
  //     className: "XXsmall",
  //     frozen: true,
  //     alignFrozen: "left",
  //   },
  //   {
  //     header: "TipoProducto",
  //     handerEn: "Product Type",
  //     field: "NombreCategoria",
  //     frozen: true,
  //     className: "small",
  //   },
  //   {
  //     header: "Categoría",
  //     handerEn: "Category",
  //     frozen: true,
  //     field: "NombreSubcategoria",
  //     className: "small",
  //   },
  //   {
  //     header: "Unidad",
  //     frozen: true,
  //     handerEn: "Unit",
  //     field: "UnitName",
  //     className: "Xsmall",
  //   },


  //   //INICIALES
  //   {
  //     headerName: "Iniciales",
  //     children: [
  //       {
  //         header: "Inicial",
  //         handerEn: "Initial",
  //         field: "Inicial",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         editable: userAuth?.IdRol === 1,
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         handerEn: "PriceL",
  //         field: "PrecioInicialL",
  //         className: "Xsmall",
  //         editable: userAuth?.IdRol === 1,
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioD",
  //         handerEn: "PriceD",
  //         field: "PrecioInicialD",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         handerEn: "MounthL",
  //         field: "InicialMontol",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         handerEn: "MounthD",
  //         editable: userAuth?.IdRol === 1,
  //         field: "InicialMontoD",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   },

  //   mostrarDetalle ?
  //   // COMPRAS REALES
  //   {
  //     headerName: "Compras Reales",
  //     children: [
  //       {
  //         header: "ComprasReales",
  //         handerEn: "Purchase",
  //         field: "ComprasReales",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         handerEn: "PriceL",
  //         field: "ComprasRealPrecioL",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioD",
  //         handerEn: "PriceD",
  //         field: "ComprasRealPrecioD",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         handerEn: "MounthL",
  //         field: "ComprasRealMontoL",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "MounthD",
  //         field: "ComprasRealMontoD",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   } : null,
    
  //   //DEVOLUCION PROVEEDOR
  //   mostrarDetalle ?
  //   {
  //     headerName: "Devolución Proveedor",
  //     children: [
  //       {
  //         header: "Devolucion Proveedor",
  //         handerEn: "",
  //         field: "DevolucionProveedor",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         handerEn: "PriceL",
  //         field: "PrecioDevProveedorL",
  //         className: "Xsmall",
  //         editable: userAuth?.IdRol === 1,
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioD",
  //         handerEn: "PriceD",
  //         field: "PrecioDevProveedorD",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         handerEn: "MounthL",
  //         editable: userAuth?.IdRol === 1,
  //         field: "MontoDevProveedorL",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "MounthD",
  //         field: "MontoDevProveedorD",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   } : null,

  //   // COMPRAS
  //   {
  //     headerName: "Compras",
  //     children: [
  //       {
  //         header: "Compras",
  //         handerEn: "Purchase",
  //         field: "Compras",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         handerEn: "PriceL",
  //         editable: userAuth?.IdRol === 1,
  //         field: "ComprasPrecioL",
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioD",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "PriceD",
  //         field: "ComprasPrecioD",
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         handerEn: "MounthL",
  //         field: "ComprasMontoL",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         handerEn: "MounthD",
  //         className: "Xsmall",
  //         field: "ComprasMontoD",          
  //         editable: userAuth?.IdRol === 1,
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   },

  //   //SALIDAS REALES
  //   mostrarDetalle ?
  //   {
  //     headerName: "Salidas Reales",
  //     children: [
  //       {
  //         header: "SalidasReales",
  //         handerEn: "Output",
  //         field: "SalidasReales",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "PriceL",
  //         field: "PrecioSalidaRealL",
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioD",
  //         handerEn: "PriceD",
  //         editable: userAuth?.IdRol === 1,
  //         field: "PrecioSalidaRealD",
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "MounthL",
  //         field: "MontoSalidaRealL",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         handerEn: "MounthD",
  //         editable: userAuth?.IdRol === 1,
  //         field: "MontoSalidaRealD",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   } : null,
    
  //   //DEVOLUCION INTERNA
  //   mostrarDetalle ?
  //   {
  //     headerName: "Devolución Interna",
  //     children: [
  //       {
  //         header: "Devolucion Interna",
  //         handerEn: "",
  //         field: "DevolucionInterna",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         handerEn: "PriceL",
  //         field: "PrecioDevInternaL",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         editable: userAuth?.IdRol === 1,
  //         header: "PrecioD",
  //         handerEn: "PriceD",
  //         field: "PrecioDevInternaD",
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "MounthL",
  //         field: "MontoDevInternaL",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         handerEn: "MounthD",
  //         editable: userAuth?.IdRol === 1,
  //         field: "MontoDevInternaD",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   } : null,

  //   //SALIDAS
  //   {
  //     headerName: "Salidas",
  //     children: [
  //       {
  //         header: "Salidas",
  //         handerEn: "Output",
  //         field: "Salidas",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         handerEn: "PriceL",
  //         field: "PrecioSalidaL",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioD",
  //         handerEn: "PriceD",
  //         field: "PrecioSalidaD",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         handerEn: "MounthL",
  //         editable: userAuth?.IdRol === 1,
  //         field: "MontoSalidaL",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         handerEn: "MounthD",
  //         field: "MontoSalidaD",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   },


  //   //INVENTARIO CALCULADO
  //   {
  //     headerName: "Inventario Calculado",
  //     children: [
  //       {
  //         header: "Inv. Calculado",
  //         handerEn: "",
  //         field: "InventarioCalculado",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioL",
  //         handerEn: "PriceL",
  //         field: "InvPrecioL",
  //         className: "Xsmall",
  //         editable: userAuth?.IdRol === 1,
  //         Format: "Currency",
  //       },
  //       {
  //         header: "PrecioD",
  //         handerEn: "PriceD",
  //         field: "InvPrecioD",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoL",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "MounthL",
  //         field: "InvMontoL",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //       {
  //         header: "MontoD",
  //         handerEn: "MounthD",
  //         field: "InvMontoD",
  //         editable: userAuth?.IdRol === 1,
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //       },
  //     ],
  //   },

  //   //INVENTARIO
  //   {
  //     headerName: "Inventario",
  //     children: [
  //       {
  //         header: "Inv",
  //         handerEn: "",
  //         field: "Inventario",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         editable: userAuth?.IdRol === 1,
  //         Format: "Currency",
  //         frozen: true,
  //         alignFrozen: "right",
  //       },
  //       {
  //         header: "DIFF",
  //         editable: userAuth?.IdRol === 1,
  //         handerEn: "",
  //         field: "DIFF",
  //         className: "Xsmall",
  //         Sumary: "sum",
  //         Format: "Currency",
  //         frozen: true,
  //         alignFrozen: "right",
  //       },
  //       // {
  //       //   field: "IdProduct",
  //       //   header: "",
  //       //   Format: "Botones",
  //       //   frozen: true,
  //       //   alignFrozen: "right",
  //       //   filter: false,
  //       //   Botones: [
  //       //     {
  //       //       icon: "pi pi-print",
  //       //       tooltip: "Imprimir",
  //       //       onClick: (rowData) => {
  //       //         if(rowData?.IdProduct){
  //       //           if(selected.length === 0){
  //       //             setShowDialogCodigo(true);
  //       //             setSelected([rowData]);
  //       //           }else{
  //       //             setShowDialogCodigo(true);
  //       //             setSelected(selected);
  //       //           }
  //       //         }
  //       //       },
  //       //       tooltipOptions: {
  //       //         position: "right",
  //       //       },
  //       //     },
  //       //     {
  //       //       icon: "pi pi-eye",
  //       //       tooltip: "Img",
  //       //       onClick: async (rowData) => {
  //       //         if(rowData?.IdProduct){
  //       //           verImagen(rowData)
  //       //         }
  //       //       },
  //       //       tooltipOptions: {
  //       //         position: "top",
  //       //       },
  //       //     },
  //       //   ],
  //       // },
  //     ],
  //   },

  //   {
  //     header: "MontoL",
  //     handerEn: "MounthL",
  //     field: "MontoL",
  //     className: "Xsmall",
  //     editable: userAuth?.IdRol === 1,
  //     Sumary: "sum",
  //     Format: "Currency",
  //     hidden: mostrarDetalle
  //   },
  //   {
  //     header: "MontoD",
  //     handerEn: "MounthD",
  //     field: "MontoD",
  //     className: "Xsmall",
  //     Sumary: "sum",
  //     editable: userAuth?.IdRol === 1,
  //     Format: "Currency",
  //     hidden: mostrarDetalle,
  //   },
  //   {
  //     header: "Diff. MontoL",
  //     handerEn: "",
  //     field: "MontoLDIFF",
  //     className: "Xsmall",
  //     Sumary: "sum",
  //     editable: userAuth?.IdRol === 1,
  //     Format: "Currency",
  //     hidden: mostrarDetalle
  //   },
  //   {
  //     header: "Diff. MontoD",
  //     handerEn: "",
  //     field: "MontoDDIFF",
  //     className: "Xsmall",
  //     Sumary: "sum",
  //     editable: userAuth?.IdRol === 1,
  //     Format: "Currency",
  //     hidden: mostrarDetalle
  //   },


  // ];

  const footerContent = (
    <div>
      <Button
        label="Codigo QR"
        className="p-button-text"
        onClick={() => {
          if(selected.length === 0 ){
            window.open(
              `${process.env.REACT_APP_ENV}/EtiquetaProductoQR/print/${selected?.CodigoProducto}/1`,
              selected[0]?.CodigoProducto,
              "height=1200,width=1000",
              setShowDialogCodigo(false)
            )
            setSelected([])
          }else{
            const selectedCodes = [];
            selected?.forEach((product) =>
              selectedCodes.push(product.CodigoProducto)
            );
            window.open(
              `${process.env.REACT_APP_ENV}/EtiquetaProductoQR/print/${selectedCodes}/1`,
              selectedCodes,
              "height=1200,width=1000"
            );
            setShowDialogCodigo(false);
            // setSelected([])
          }
        }}
      />
      <Button
        label="Codigo de Barras"
        className="p-button-text"
        onClick={() => {
          if (selected.length === 0) {
            window.open(
              `${process.env.REACT_APP_ENV}/EtiquetaProducto/print/${selected?.CodigoProducto}/2`,
              selected[0]?.CodigoProducto,
              "height=1200,width=1000",
              setShowDialogCodigo(false)
            );
            setSelected([])
          } else {
            const selectedCodes = [];
            selected.forEach((product) =>
              selectedCodes.push(product.CodigoProducto)
            );
            window.open(
              `${process.env.REACT_APP_ENV}/EtiquetaProducto/print/${selectedCodes}/2`,
              selectedCodes,
              "height=1200,width=1000"
            );
            setShowDialogCodigo(false);
            // setSelected([])
          }
        }}
      />
    </div>
  );

  const table = {
    Columns: columns,
    Data: inventario,
    loading: loading,
    showModal: (e) => showModal(e),
  };

  const showModal = (e) => {};

  const ComfirmCierre = () => {
    setShowConfirmDialog(true);
  };

  const onHideConfirmDialog = () => {
    setShowConfirmDialog(false);
  };

  const onConfirmCierre = () => {
    ejecutarCierre()
  };

  const ejecutarCierre = async () => {
    setLoading(true)
    const respuesta =  await generarCierreMP(userAuth?.IdUser)
    const resp = await generarExcelCierreMP()
    if(respuesta[0].ESTADO === 1){
      toastShow(toast, "success", "Realizado", respuesta[0].MENSAJE);
      setShowConfirmDialog(false);
    }else{
      toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
    }
    setLoading(false)
  }

  useEffect(() => {
    if (showDialog) {
      getImagenes();
    }
  }, [showDialog]);

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "inventarioMP", config.language));
    getInfo();
  }, [activeIndex]);

  const cerrarImagen = () => {
    setShowDialog(false)
  }

  const message = `¿Está seguro de generar el cierre de ${mesCierre?.MesEsLargo} - ${mesCierre?.Anio}?`;

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="d-flex gap-2">
            <h3>{getLabel(baseLang, "inventarioMP", config.language)}</h3>
            {activeIndex === 0 && <Button icon="pi pi-refresh" onClick={getInfo} /> }
            {activeIndex === 0 && <Button tooltip={mostrarDetalle ? 'Ocultar Detalles' : 'Mostrar Detalles'} onClick={() => { setMostrarDetalle(!mostrarDetalle) }} icon='pi pi-eye' className='mx-2' />}            
            <div>
              {activeIndex === 0 && (accesoGenerarCierre || userAuth?.IdRol === 1) &&                   
                <Button icon='ri ri-settings-3-line' onClick={ComfirmCierre}
                  loading={loading}>  <label className="mx-2">
                    Generar Cierre {mesCierre?.MesEsLargo} - {mesCierre?.Anio}
                  </label>
                </Button>
              }
            </div>
          </div>
          
        }
        contenido={
          <div className="mt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Inventario">
                <div style={{ height: "82vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>

              <TabPanel header="Historico">
                <InventarioHistoricoTabMP/>
              </TabPanel>

              <TabPanel header="Toma de Inventario">
                <TomaInventarioScreen IdTipoIngreso ={2}/>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      <Dialog header={selectedImg ? selectedImg?.CodigoProducto + ' - '  + selectedImg?.NombreProducto : "" } visible={showDialog} onHide={cerrarImagen} className="w-50">
        <div>
          {imagenes?.CodigoProducto && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>


      {showDialogCodigo && (
        <Dialog
          header="Imprimir Etiqueta"
          visible={showDialogCodigo}
          style={{ width: "30vw" }}
          onHide={() => setShowDialogCodigo(false)}
          footer={footerContent}
        >
          <p className="m-0">Elija la etiqueta que desea Imprimir</p>
        </Dialog>
      )}



      <ConfirmDialog
        visible={showConfirmDialog}
        onHide={onHideConfirmDialog}
        message={message}
        header="Confirmación"
        icon="pi pi-exclamation-triangle"
        acceptLabel="Sí"
        rejectLabel="No"
        accept={onConfirmCierre}
        reject={onHideConfirmDialog}
      />


    </div>
  );
};

export default InventarioMateriaPrimaScreen;
